import styled from 'styled-components';
import { useGetProductsQuery } from '../../../../../hooks/api/product/queries/useGetProducts.query';
import { IProduct } from '../../../../../interfaces/Product.interfaces';
import { ProductPreviewCardSwiperWrapper } from '../../../listView/ProductPreviewCard/ProductPreviewCardSwiperWrapper';
import { SecitionDivideLine } from './SecitionDivideLine';

interface ProductMorePartnerProductSectionProps {
  product: IProduct;
}

export const ProductMorePartnerProductSection = ({ product }: ProductMorePartnerProductSectionProps) => {
  const { data: partnerProducts } = useGetProductsQuery({
    searchParam: {
      category: 'PARTNER',
      status: 'ONSALE',
      count: 5,
    },
  });

  if (partnerProducts && partnerProducts.length >= 3) {
    return (
      <>
        <Container>
          <ProductPreviewCardSwiperWrapper
            products={partnerProducts}
            category={'partner'}
            pageType={'pdp'}
            currentProductForMarketAmpliEvent={product}
            title={'플루바 할부가 가능한 파트너 매물'}
          />
        </Container>

        <SecitionDivideLine />
      </>
    );
  }

  return <></>;
};

const Container = styled.div`
  display: flex;
  padding: 32px var(--radius-large, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;
